/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IMedicalHistory } from 'app/shared/model/medical-history.model';
import { IICD10Diagnosis } from 'app/shared/model/icd-10-diagnosis.model';

export interface IDiagnosisHistory {
  id?: string;
  snomedConceptId?: string;
  snomedConceptText?: string;
  active?: boolean;
  timestampentry?: number;
  microSec?: number;
  lastupdated?: number;
  cursor?: number;
  medicalHistory?: IMedicalHistory;
  icdDiagnosis?: IICD10Diagnosis;
}

export const defaultValue: Readonly<IDiagnosisHistory> = {
  active: false,
};
